/**
 * RefundList
 * --
 */
import React, { useState, useEffect } from 'react';
import { Button, Table, Tag } from 'antd';
import { Content, Title, Row, Col, ModalLayout } from 'components';
import moment from 'moment';
import MessageAlert, { strCut, stringToMoneyFormat } from 'utils';
import * as XLSX from 'xlsx/xlsx.mjs';
import { JM_PAY_TYPE } from 'constants/JMPayConstant';

/**----------------------------------------
 * [Component] JM페이 > 유저목록
 * ----------------------------------------
 */
const RefundList = ({ data, currentRow, onSelect }) => {
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  console.log('[RefundList] data: ', data);

  // JSX: start
  return (
    <>
      <Content maxWidth={'100%'} padding={0} backgroundColor={'none'}>
        {/* === 상단 > 타이틀 === */}
        <Title
          size={5}
          style={{ marginBottom: 7.5 }}
          subButton={<Button>엑셀 다운로드</Button>}
        >
          환불신청 및 취소내역({data?.length ?? 0})
        </Title>

        {/* ===== 데이터 테이블: start ===== */}
        <div style={{ overflow: 'auto', width: '100%', height: '100%' }}>
          <Table
            className="boxShadow"
            bordered
            size="small"
            dataSource={data ?? []}
            scroll={{
              x: 'max-content',
            }}
            pagination={{ pageSize: 45 }}
            style={{ minHeight: 580 }}
            onRow={(record) => {
              return {
                onClick: () => onSelect(record), // 행 클릭 시 이벤트 처리
              };
            }}
            columns={[
              {
                title: '결제번호',
                dataIndex: 'jm_pay_id',
                width: 130,
                align: 'center',
              },
              {
                title: '결제일(시간)',
                dataIndex: 'created_at',
                width: 210,
                align: 'center',
                render: (value) =>
                  moment(value * 1000).format('YYYY-MM-DD (HH:mm:ss)'),
              },
              {
                title: '결제수단',
                dataIndex: 'order_route',
                width: 130,
                align: 'center',
              },
              {
                title: '사용금액',
                dataIndex: 'price',
                width: 150,
                align: 'center',
                render: (value) => stringToMoneyFormat(value),
              },
              {
                title: '분류',
                dataIndex: 'type',
                width: 130,
                align: 'center',
                render: (value) => (
                  <Tag color={JM_PAY_TYPE[value]?.color}>
                    {JM_PAY_TYPE[value]?.label}
                  </Tag>
                ),
              },
              {
                title: '결제후 잔액',
                dataIndex: 'current_balance',
                width: 150,
                align: 'center',
                render: (value) => stringToMoneyFormat(value ?? 0),
              },
              {
                title: '회원명',
                dataIndex: 'user',
                width: 170,
                align: 'center',
                render: (value) => (
                  <a style={{ textDecoration: 'underline' }}>{`${
                    value?.user_name
                  }(${value?.user_gender}, ${value?.user_nickname ?? '-'})`}</a>
                ),
              },
              {
                title: '연락처',
                dataIndex: 'user',
                // width: 150,
                align: 'center',
                render: (user) => user?.user_phone,
              },
            ]}
          />
        </div>
        {/* ===== 데이터 테이블: end ===== */}
      </Content>

      {/* ===== 상세모달: start ===== */}
      <ModalLayout
        type="drawer"
        maxWidth={1000}
        isOpen={currentRow !== null}
        open={currentRow !== null}
        title="주문상세"
        closable={true}
        onCancel={() => onSelect(null)}
      ></ModalLayout>
      {/* ===== 상세모달: end ===== */}
    </>
  ); // JSX: end
};

RefundList.defaultProps = {
  onSelect: () => {},
};
export default RefundList;
